import React from 'react';

import { CircularProgress, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
const useStyles = makeStyles()(theme => ({
  conversionLoading: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    height: '100%',
    justifyContent: 'center',
  },
  loading: {
    backgroundColor: theme.appColors.defaultFieldBackground,
    flexGrow: 1,
    height: '100%',
    width: '100%',
  },
}));

interface ConversionLoadingProps {
  description?: string;
  message?: string;
}

export function ConversionLoading({
  description = 'Please wait while we prepare your document.',
  message = 'Converting document...',
}: ConversionLoadingProps): JSX.Element {
  const { classes } = useStyles();

  return (
    <div className={classes.loading}>
      <div className={classes.conversionLoading}>
        <CircularProgress />
        <Typography variant="h6">{message}</Typography>
        <Typography color="textSecondary" variant="body2">
          {description}
        </Typography>
      </div>
    </div>
  );
}
